function myFunction() {
    const element = document.getElementById("tab-item-1");
    const vgx = document.getElementById("tab-item-5");
    element.scrollIntoView();
    vgx.parentElement.parentElement.scrollIntoView();
  }

  function funcClick() {
    const element = document.getElementById("tab-item-2");
    const vgx = document.getElementById("tab-item-6");
    element.scrollIntoView();
    vgx.scrollIntoView();
  }

  function func() {
    const element = document.getElementById("tab-item-3");
    const vgx = document.getElementById("tab-item-7");
    element.scrollIntoView();
    vgx.scrollIntoView();
  }

  function sclick() {
    const element = document.getElementById("tab-item-4");
    const vgx = document.getElementById("tab-item-8");
    element.scrollIntoView();
    vgx.parentElement.scrollIntoView();
  }